import BoxImg from "public/openStack/workloads/providers.png";
import MobileImg from "public/openStack/workloads/material-symbols_developer-mode.png";
import RoboImg from "public/openStack/workloads/material-icon-theme_robots.png";
import BankImg from "public/openStack/workloads/dashicons_bank.png";

export const USE_CASES_CONSTANTS = [
  {
    image: BoxImg,
    title: "Service Providers & CSPs",
    text: "Launch secure IaaS with full tenant control",
  },
  {
    image: BankImg,
    title: "Enterprises & Regulated Industries",
    text: "Keep sensitive data in-region",
  },
  {
    image: MobileImg,
    title: "SaaS & DevOps Teams",
    text: "Power pipelines, test/dev, and apps at scale",
  },
  {
    image: RoboImg,
    title: "AI/ML & HPC",
    text: "Leverage GPU and high-density compute clusters",
  },
];
